/* import __COLOCATED_TEMPLATE__ from './string-question.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestionTypesStringQuestion extends Component {
  @action
  onTextChange(question, value) {
    this.args.onChange?.(question, value);
  }
}
